<div class="logo-container">
  <span inlineSVG="/logo/logo-dark-pauly.svg"></span>
</div>
<div class="app-container">
  <router-outlet></router-outlet>
</div>
